import React from 'react';
import styled, { css } from 'styled-components';
import { useTranslation } from 'react-i18next';
import { Path } from '../Routing/Paths';
import { themeColor } from '../Theming';
import { Link } from 'react-router-dom';
import DropDownMenu, {
  DropDownItemProps,
} from './Components/DropDown/DropDownMenu';
import env from '../env';

const Container = styled.nav`
  display: flex;
  justify-content: flex-end;
  gap: 0 50px;
  align-items: center;
`;

const sharedStyling = css`
  color: ${themeColor('darkestGrey')};
  font-size: 0.875rem;
  line-height: 1.5rem;
  text-decoration: none;
  overflow: hidden;
  flex-shrink: 0;
  text-align: center;
  font-weight: 700;

  &.selected::after {
    content: '';
    width: 72px;
    height: 3px;
    border-radius: 1.5px;
    background: ${themeColor('darkestGrey')};
    margin: 10px auto 0;
    display: block;
  }
  &:focus {
    color: ${themeColor('darkestGrey')};
    text-decoration: none;
  }
`;

const StyledLink = styled(Link)`
  ${sharedStyling}
  text-align: unset;

  &:hover {
    color: ${themeColor('lightGreen')};
  }
`;

const StyledButtonLink = styled.a`
  ${sharedStyling}
  padding: 0 40px;
  background-color: ${themeColor('darkBlue')};
  color: ${themeColor('white')};
  height: 42.84px;
  border-radius: 29px;
  display: grid;
  place-items: center;
  margin-left: 6px;
`;

interface MainMenuProps {
  className?: string;
}

const MainMenu: React.FC<MainMenuProps> = ({ className }) => {
  const { t } = useTranslation();

  return (
    <Container className={className}>
      <DropDownMenu items={PRODUCTS_MENU_ITEMS}>
        {t('navigation.products')}
      </DropDownMenu>
      <DropDownMenu items={BENEFITS_MENU_ITEMS}>
        {t('navigation.benefits')}
      </DropDownMenu>
      <StyledLink to={Path.Gaming}>{t('navigation.gaming')}</StyledLink>
      <DropDownMenu items={ABOUT_MENU_ITEMS}>
        {t('navigation.aboutKindred')}
      </DropDownMenu>
      <StyledLink to={{ pathname: env.blog_link }} target="_blank">
        {t('navigation.blog')}
      </StyledLink>
      <StyledButtonLink href={Path.RequestADemo}>
        {t('navigation.bookADemo')}
      </StyledButtonLink>
    </Container>
  );
};

export default MainMenu;

const BENEFITS_MENU_ITEMS: DropDownItemProps[] = [
  {
    text: 'footer.monetization',
    link: Path.Revenue,
  },
  {
    text: 'navigation.loyalty',
    link: Path.Loyalty,
  },
  {
    text: 'navigation.esg',
    link: Path.ESG,
  },
];

const PRODUCTS_MENU_ITEMS: DropDownItemProps[] = [
  {
    text: 'navigation.allProducts',
    link: Path.ProductHome,
  },
  {
    text: 'navigation.mobileExtension',
    link: Path.ProductExtension,
  },
  {
    text: 'navigation.desktopExtension',
    link: Path.ProductDesktop,
  },
  {
    text: 'navigation.dealsApi',
    link: Path.ProductApi,
  },
];

const ABOUT_MENU_ITEMS: DropDownItemProps[] = [
  {
    text: 'navigation.aboutKindred',
    link: Path.AboutUs,
  },
  {
    text: 'navigation.ourNetwork',
    link: Path.Network,
  },
];
